import { createApp } from 'vue'
import App from './App.vue'

import appRouter from './router.js'
import store from './store/index.js'

import BaseButton from '@/ui/BaseButton.vue'
import BaseWidget from '@/ui/BaseWidget.vue'
import BaseSpinner from '@/ui/BaseSpinner.vue'
import TheHeader from "@/layouts/TheHeader.vue";
import BaseWidgetCard from '@/ui/BaseWidgetCard.vue'
import BaseWidgetBody from '@/ui/BaseWidgetBody.vue'
import BaseWidgetList from '@/ui/BaseWidgetList.vue'
import BaseWidgetHeader from '@/ui/BaseWidgetHeader.vue'
import PostListItem from '@/components/PostListItem.vue'
import FriendSearch from "@/components/FriendSearch.vue"
import PostListInput from '@/components/PostListInput.vue'
import PostListAuthor from '@/components/PostListAuthor.vue'
import PostListAction from '@/components/PostListAction.vue'
import PostListComment from '@/components/PostListComment.vue'
import PostListContent from '@/components/PostListContent.vue'
import PostListActivity from '@/components/PostListActivity.vue'
import PostListItemButton from '@/components/PostListItemButton.vue'
import PostListCommentItem from '@/components/PostListCommentItem.vue'
import PostListCommentInput from '@/components/PostListCommentInput.vue'

const app = createApp(App)

app.use(store)
app.use(appRouter)

app.component('the-header', TheHeader)
app.component('base-widget', BaseWidget)
app.component('base-button', BaseButton)
app.component('base-spinner', BaseSpinner)
app.component('friend-search', FriendSearch)
app.component('post-list-item', PostListItem)
app.component('post-list-input', PostListInput)
app.component('base-widget-card', BaseWidgetCard)
app.component('post-list-action', PostListAction)
app.component('base-widget-body', BaseWidgetBody)
app.component('base-widget-list', BaseWidgetList)
app.component('post-list-author', PostListAuthor)
app.component('post-list-content', PostListContent)
app.component('post-list-comment', PostListComment)
app.component('base-widget-header', BaseWidgetHeader)
app.component('post-list-activity', PostListActivity)
app.component('post-list-item-button', PostListItemButton)
app.component('post-list-comment-item', PostListCommentItem)
app.component('post-list-comment-input', PostListCommentInput)

app.mount('#app')
